import SettingMobile from './container'

export default SettingMobile